import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";

import { SHORT_DAYS } from "../../consts/strings";
import { palette } from "../../theme/palette";
import { View } from "../View";
import { DriverIcon } from "../Icons/Driver";

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: "-0.2rem",
    marginLeft: "0.2rem",
  },
  inline: {
    display: "flex",
    flexDirection: "row",
    marginTop: "4px",
  },
  dayHeader: {
    width: "1.5rem",
  },
  text: {
    fontSize: "12px",
    color: palette.typography.white.high,
    lineHeight: "16px",
  },
  space: {
    width: "0.2rem",
  },
  flexSpace: {
    flex: 1,
  },
  driversContainer: {
    display: "flex",
    alignItems: "center",
  },
  driverIcon: {
    height: "1rem",
    width: "1rem",
    fill: "transparent",
  },
});
export const SectionCardDayRow = ({ dayOfWeek, section }) => {
  const styles = useStyles();
  const { shiftManagerName, shiftManagerCode, drivers } =
    section.days[dayOfWeek];

  return (
    <View className={clsx(styles.text, styles.inline)}>
      <View className={styles.dayHeader}>{`${SHORT_DAYS[dayOfWeek]}: `}</View>
      <View>{shiftManagerName || shiftManagerCode}</View>
      <View className={styles.flexSpace} />
      <View className={styles.driversContainer}>
        <DriverIcon className={styles.driverIcon} color={palette.white} />
        {`${drivers.length}`.padStart(3, "0")}
      </View>
      <View className={styles.space} />
    </View>
  );
};

export const SectionCardContent = ({ section }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      {[1, 2, 3, 4, 5, 6, 0].map((dayOfWeek) => (
        <View key={dayOfWeek}>
          <SectionCardDayRow dayOfWeek={dayOfWeek} section={section} />
        </View>
      ))}
    </View>
  );
};
